export const trackAddPaymentInfoEvent = ({ eventId }) => {
    if (!eventId) throw new Error('Error Facebook Pixel eventId is required');

    const fbp = getFbp();
    const fbc = getFbc();

    window.fbq('track', FACEBOOK_PIXEL_STANDARD_EVENTS.ADD_PAYMENT_INFO, 
        { 
            
            fbp: fbp,
                fbc: fbc
        }, 
        { 
            eventID: eventId,
            user_data: {
                fbp: fbp,
                fbc: fbc
            }
        }
    );
};

export const trackStartTrialEvent = ({ eventId }) => {
    if (!eventId) throw new Error('Error Facebook Pixel eventId is required');

    const fbp = getFbp();
    const fbc = getFbc();

    window.fbq('track', FACEBOOK_PIXEL_STANDARD_EVENTS.START_TRIAL, 
        { 
           
            fbp: fbp,
                fbc: fbc
        }, 
        { 
            eventID: eventId,
            user_data: {
                fbp: fbp,
                fbc: fbc
            }
        }
    );
};

export const trackInitiateCheckoutEvent = ({ eventId }) => {
    if (!eventId) throw new Error('Error Facebook Pixel eventId is required');

    const fbp = getFbp();
    const fbc = getFbc();

    window.fbq('track', FACEBOOK_PIXEL_STANDARD_EVENTS.INITIATE_CHECKOUT, 
        { 
            
            fbp: fbp,
                fbc: fbc
        }, 
        { 
            eventID: eventId,
            user_data: {
                fbp: fbp,
                fbc: fbc
            }
        }
    );
};

// Helper function to get Facebook Browser Parameter (fbp)
const getFbp = () => {
    const cookies = document.cookie.split(';');
    const fbpCookie = cookies.find(cookie => cookie.trim().startsWith('_fbp='));
    return fbpCookie ? fbpCookie.split('=')[1] : null;
};

// Helper function to get Facebook Click ID (fbc)
const getFbc = () => {
    const cookies = document.cookie.split(';');
    const fbcCookie = cookies.find(cookie => cookie.trim().startsWith('_fbc='));
    return fbcCookie ? fbcCookie.split('=')[1] : null;
};

const FACEBOOK_PIXEL_STANDARD_EVENTS = {
    ADD_PAYMENT_INFO: 'AddPaymentInfo',
    START_TRIAL: 'StartTrial',
    INITIATE_CHECKOUT: 'InitiateCheckout',
};
